// @ts-nocheck
/* eslint-disable */
import type { CalendarDate } from '@internationalized/date';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date string in YYYY-MM-DD format */
  CalendarDate: { input: CalendarDate; output: CalendarDate; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar.This scalar is serialized to a string in ISO 8601 format and parsed from a string in ISO 8601 format. */
  DateTimeISO: { input: string; output: string; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: { input: any; output: any; }
};

export type AnomalyScoreParts = {
  __typename?: 'AnomalyScoreParts';
  baseScore: Scalars['Float']['output'];
  finalScore: Scalars['Float']['output'];
  financialAccountAdjustment: Scalars['Float']['output'];
  merchantAdjustment: Scalars['Float']['output'];
  timingAdjustment: Scalars['Float']['output'];
};

export type Bank = IEntity & INode & {
  __typename?: 'Bank';
  id: Scalars['ID']['output'];
  logoBase64Encoding?: Maybe<Scalars['String']['output']>;
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  primaryColor?: Maybe<Scalars['String']['output']>;
};

export type BankConnection = INode & {
  __typename?: 'BankConnection';
  accounts: Array<FinancialAccount>;
  bank: Bank;
  externalId: Scalars['String']['output'];
  hasPotentialSyncIssue: Scalars['Boolean']['output'];
  historicalSyncComplete: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  lastSyncedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  unhealthyConnectionCallout?: Maybe<Callout>;
  user: User;
};

export type Bill = INode & {
  __typename?: 'Bill';
  accountNumber?: Maybe<Scalars['String']['output']>;
  amountDue: Scalars['String']['output'];
  amountPaid: Scalars['String']['output'];
  amountRemaining: Scalars['String']['output'];
  billSubmission?: Maybe<BillSubmission>;
  createdAt: Scalars['DateTimeISO']['output'];
  currencyCode: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  documents: Array<Document>;
  dueDate: Scalars['CalendarDate']['output'];
  id: Scalars['ID']['output'];
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  isAutopay?: Maybe<Scalars['Boolean']['output']>;
  lateFeeAmount?: Maybe<Scalars['String']['output']>;
  lateFeeDate?: Maybe<Scalars['CalendarDate']['output']>;
  merchant?: Maybe<Merchant>;
  minAmountDue?: Maybe<Scalars['String']['output']>;
  payerName?: Maybe<Scalars['String']['output']>;
  paymentUrl?: Maybe<Scalars['String']['output']>;
  previousAccountBalance?: Maybe<Scalars['String']['output']>;
  providerEmail?: Maybe<Scalars['String']['output']>;
  providerName: Scalars['String']['output'];
  providerPhone?: Maybe<Scalars['String']['output']>;
  recurringTransaction?: Maybe<RecurringTransaction>;
  senderIdentifier?: Maybe<Scalars['String']['output']>;
  serviceEndDate?: Maybe<Scalars['CalendarDate']['output']>;
  serviceStartDate?: Maybe<Scalars['CalendarDate']['output']>;
  source: BillSource;
  statementDate?: Maybe<Scalars['CalendarDate']['output']>;
  status: BillStatus;
  transactions: Array<Transaction>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type BillFilters = {
  merchantIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  recurringTransactionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  status?: InputMaybe<BillStatus>;
};

/** Source of bill data */
export enum BillSource {
  Assistant = 'ASSISTANT',
  Email = 'EMAIL',
  Sms = 'SMS',
  User = 'USER'
}

/** Status of a bill */
export enum BillStatus {
  Paid = 'PAID',
  PartiallyPaid = 'PARTIALLY_PAID',
  Unpaid = 'UNPAID'
}

export type BillSubmission = INode & {
  __typename?: 'BillSubmission';
  accountNumber?: Maybe<Scalars['String']['output']>;
  amountDue?: Maybe<Scalars['String']['output']>;
  bill?: Maybe<Bill>;
  createdAt: Scalars['DateTimeISO']['output'];
  currencyCode: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  documents: Array<Document>;
  dueDate?: Maybe<Scalars['CalendarDate']['output']>;
  id: Scalars['ID']['output'];
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  isAutopay?: Maybe<Scalars['Boolean']['output']>;
  lateFeeAmount?: Maybe<Scalars['String']['output']>;
  lateFeeDate?: Maybe<Scalars['CalendarDate']['output']>;
  minAmountDue?: Maybe<Scalars['String']['output']>;
  payerName?: Maybe<Scalars['String']['output']>;
  paymentUrl?: Maybe<Scalars['String']['output']>;
  previousAccountBalance?: Maybe<Scalars['String']['output']>;
  providerEmail?: Maybe<Scalars['String']['output']>;
  providerName?: Maybe<Scalars['String']['output']>;
  providerPhone?: Maybe<Scalars['String']['output']>;
  rawAmountDue?: Maybe<Scalars['String']['output']>;
  rawDueDate?: Maybe<Scalars['String']['output']>;
  rawJson?: Maybe<Scalars['JSONObject']['output']>;
  rawLateFeeAmount?: Maybe<Scalars['String']['output']>;
  rawLateFeeDate?: Maybe<Scalars['String']['output']>;
  rawMinAmountDue?: Maybe<Scalars['String']['output']>;
  rawPreviousAccountBalance?: Maybe<Scalars['String']['output']>;
  rawServiceEndDate?: Maybe<Scalars['String']['output']>;
  rawServiceStartDate?: Maybe<Scalars['String']['output']>;
  rawStatementDate?: Maybe<Scalars['String']['output']>;
  senderIdentifier?: Maybe<Scalars['String']['output']>;
  serviceEndDate?: Maybe<Scalars['CalendarDate']['output']>;
  serviceStartDate?: Maybe<Scalars['CalendarDate']['output']>;
  source: BillSubmissionSource;
  statementDate?: Maybe<Scalars['CalendarDate']['output']>;
  status: BillSubmissionStatus;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type BillSubmissionFilters = {
  merchantId?: InputMaybe<Scalars['ID']['input']>;
  recurringTransactionId?: InputMaybe<Scalars['ID']['input']>;
  source?: InputMaybe<BillSubmissionSource>;
  status?: InputMaybe<BillSubmissionStatus>;
};

/** Source of a bill submission */
export enum BillSubmissionSource {
  Assistant = 'ASSISTANT',
  Email = 'EMAIL',
  Sms = 'SMS'
}

/** Status of a bill submission */
export enum BillSubmissionStatus {
  Converted = 'CONVERTED',
  NeedsReview = 'NEEDS_REVIEW',
  Rejected = 'REJECTED'
}

export type Callout = INode & {
  __typename?: 'Callout';
  bankConnection?: Maybe<BankConnection>;
  dismissed: Scalars['Boolean']['output'];
  eventDate: Scalars['DateTimeISO']['output'];
  feedbackNotes?: Maybe<Scalars['String']['output']>;
  feedbackRating?: Maybe<Scalars['Int']['output']>;
  financialAccount?: Maybe<FinancialAccount>;
  id: Scalars['ID']['output'];
  merchant?: Maybe<Merchant>;
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  priority: CalloutPriority;
  transaction?: Maybe<Transaction>;
  type: CalloutType;
};

export type CalloutConnection = ICalloutConnection & {
  __typename?: 'CalloutConnection';
  edges: Array<CalloutEdge>;
  pageInfo: PageInfo;
};

export type CalloutEdge = ICalloutEdge & {
  __typename?: 'CalloutEdge';
  cursor: Scalars['String']['output'];
  node: Callout;
};

export type CalloutFiltersInput = {
  financialAccountId?: InputMaybe<Scalars['String']['input']>;
  includeBankConnectionUnion?: InputMaybe<Scalars['Boolean']['input']>;
  merchantId?: InputMaybe<Scalars['String']['input']>;
};

/** Priority level for callouts */
export enum CalloutPriority {
  P0 = 'P0',
  P1 = 'P1',
  P2 = 'P2',
  P3 = 'P3',
  P4 = 'P4'
}

/** Type of callout */
export enum CalloutType {
  HighCreditUtilization = 'HIGH_CREDIT_UTILIZATION',
  LowBalance = 'LOW_BALANCE',
  UnhealthyBankConnection = 'UNHEALTHY_BANK_CONNECTION',
  UnusualCumulativeSpend = 'UNUSUAL_CUMULATIVE_SPEND',
  UnusualTransaction = 'UNUSUAL_TRANSACTION',
  UnverifiedPhone = 'UNVERIFIED_PHONE'
}

export type CalloutUpdateInputGql = {
  dismissed?: InputMaybe<Scalars['Boolean']['input']>;
  feedbackNotes?: InputMaybe<Scalars['String']['input']>;
  feedbackRating?: InputMaybe<Scalars['Int']['input']>;
};

export type CaregiverRelationship = INode & {
  __typename?: 'CaregiverRelationship';
  caregiver: User;
  createdAt: Scalars['DateTimeISO']['output'];
  dependant: Dependant;
  id: Scalars['ID']['output'];
  isInLaw: Scalars['Boolean']['output'];
  isStep: Scalars['Boolean']['output'];
  livesWithCaregiver?: Maybe<Scalars['Boolean']['output']>;
  relationship: CaregiverRelationshipKind;
  relationshipOther?: Maybe<Scalars['String']['output']>;
};

export type CaregiverRelationshipForNewDependantInput = {
  isInLaw: Scalars['Boolean']['input'];
  isStep: Scalars['Boolean']['input'];
  livesWithCaregiver?: InputMaybe<Scalars['Boolean']['input']>;
  relationship: CaregiverRelationshipKind;
  relationshipOther?: InputMaybe<Scalars['String']['input']>;
};

/** How a caregiver is related to a dependant */
export enum CaregiverRelationshipKind {
  Aunt = 'AUNT',
  Father = 'FATHER',
  Grandfather = 'GRANDFATHER',
  Grandmother = 'GRANDMOTHER',
  Mother = 'MOTHER',
  Other = 'OTHER',
  Uncle = 'UNCLE'
}

export type CreateDependantAndRelationshipInput = {
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  caregiverRelationship: CaregiverRelationshipForNewDependantInput;
  dateOfBirth?: InputMaybe<Scalars['CalendarDate']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  preferredName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateFinancialAccountsInput = {
  accounts: Array<PlaidAccountInput>;
  institutionId: Scalars['String']['input'];
};

export type CreateLinkTokenInput = {
  bankConnectionId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLinkTokenOutput = {
  __typename?: 'CreateLinkTokenOutput';
  linkToken: Scalars['String']['output'];
};

export type DeleteAccountOutput = {
  __typename?: 'DeleteAccountOutput';
  success: Scalars['Boolean']['output'];
};

export type DeleteDependantInput = {
  dependantId: Scalars['ID']['input'];
};

export type DeleteResidenceInput = {
  residenceId: Scalars['ID']['input'];
};

export type DeleteVehicleInput = {
  vehicleId: Scalars['ID']['input'];
};

export type Dependant = INode & {
  __typename?: 'Dependant';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  dateOfBirth?: Maybe<Scalars['CalendarDate']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  otherResidences: Array<Residence>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  preferredName?: Maybe<Scalars['String']['output']>;
  primaryResidence?: Maybe<Residence>;
};

export type DependantPartnership = INode & {
  __typename?: 'DependantPartnership';
  createdAt: Scalars['DateTimeISO']['output'];
  dependants: Array<Dependant>;
  id: Scalars['ID']['output'];
  liveTogether?: Maybe<Scalars['Boolean']['output']>;
  relationship: PartnerRelationship;
  relationshipOther?: Maybe<Scalars['String']['output']>;
};

export type Document = INode & {
  __typename?: 'Document';
  assetUrl: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  emailMetadata?: Maybe<DocumentEmailMetadata>;
  id: Scalars['ID']['output'];
  mimeType?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  previewUrl?: Maybe<Scalars['String']['output']>;
  sequenceNumber?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type DocumentEmailMetadata = {
  __typename?: 'DocumentEmailMetadata';
  originalFrom?: Maybe<Scalars['String']['output']>;
  originalSubject?: Maybe<Scalars['String']['output']>;
  originalTo?: Maybe<Scalars['String']['output']>;
};

export type EntitySearchInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  types: Array<EntitySearchType>;
};

export enum EntitySearchType {
  FinancialAccount = 'FINANCIAL_ACCOUNT',
  Merchant = 'MERCHANT'
}

export type ExchangePublicTokenInput = {
  accounts: Array<PlaidAccountInput>;
  institutionId: Scalars['String']['input'];
  publicToken: Scalars['String']['input'];
};

export type Family = INode & {
  __typename?: 'Family';
  caregiverRelationships: Array<CaregiverRelationship>;
  createdAt: Scalars['DateTimeISO']['output'];
  dependantPartnerships: Array<DependantPartnership>;
  dependants: Array<Dependant>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  settings: FamilySettings;
  vehicles: Array<Vehicle>;
};

export type FamilyMember = Dependant | User;

export type FamilySettings = {
  __typename?: 'FamilySettings';
  creditUtilizationThreshold: Scalars['Float']['output'];
  lowBalanceThreshold: Scalars['Float']['output'];
};

export type FinancialAccount = IEntity & INode & {
  __typename?: 'FinancialAccount';
  bank: Bank;
  bankConnection: BankConnection;
  currentBalance?: Maybe<FinancialAccountBalance>;
  historicalBalances: Array<FinancialAccountBalance>;
  id: Scalars['ID']['output'];
  /** @deprecated This field will be removed in a future version */
  lastSyncedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  mask: Scalars['String']['output'];
  name: Scalars['String']['output'];
  subtype: FinancialAccountSubtype;
  type: FinancialAccountPrimaryType;
};


export type FinancialAccountHistoricalBalancesArgs = {
  filters?: InputMaybe<FinancialAccountBalanceFilters>;
};

export type FinancialAccountBalance = INode & {
  __typename?: 'FinancialAccountBalance';
  balance: Scalars['String']['output'];
  creditLimit?: Maybe<Scalars['String']['output']>;
  financialAccount: FinancialAccount;
  id: Scalars['ID']['output'];
  timestamp: Scalars['DateTimeISO']['output'];
};

export type FinancialAccountBalanceFilters = {
  endDate: Scalars['DateTimeISO']['input'];
  startDate: Scalars['DateTimeISO']['input'];
};

export enum FinancialAccountPrimaryType {
  Credit = 'CREDIT',
  Depository = 'DEPOSITORY',
  Investment = 'INVESTMENT',
  Loan = 'LOAN',
  Other = 'OTHER',
  Payroll = 'PAYROLL'
}

export enum FinancialAccountSubtype {
  Auto = 'AUTO',
  Brokerage = 'BROKERAGE',
  Business = 'BUSINESS',
  CashIsa = 'CASH_ISA',
  CashManagement = 'CASH_MANAGEMENT',
  Cd = 'CD',
  Checking = 'CHECKING',
  Commercial = 'COMMERCIAL',
  Construction = 'CONSTRUCTION',
  Consumer = 'CONSUMER',
  CreditCard = 'CREDIT_CARD',
  CryptoExchange = 'CRYPTO_EXCHANGE',
  Ebt = 'EBT',
  EducationSavingsAccount = 'EDUCATION_SAVINGS_ACCOUNT',
  FixedAnnuity = 'FIXED_ANNUITY',
  Gic = 'GIC',
  HealthReimbursementArrangement = 'HEALTH_REIMBURSEMENT_ARRANGEMENT',
  HomeEquity = 'HOME_EQUITY',
  Hsa = 'HSA',
  Ira = 'IRA',
  Isa = 'ISA',
  Keogh = 'KEOGH',
  Lif = 'LIF',
  LifeInsurance = 'LIFE_INSURANCE',
  LineOfCredit = 'LINE_OF_CREDIT',
  Lira = 'LIRA',
  Loan = 'LOAN',
  Lrif = 'LRIF',
  Lrsp = 'LRSP',
  MoneyMarket = 'MONEY_MARKET',
  Mortgage = 'MORTGAGE',
  MutualFund = 'MUTUAL_FUND',
  NonCustodialWallet = 'NON_CUSTODIAL_WALLET',
  NonTaxableBrokerageAccount = 'NON_TAXABLE_BROKERAGE_ACCOUNT',
  Other = 'OTHER',
  OtherAnnuity = 'OTHER_ANNUITY',
  OtherInsurance = 'OTHER_INSURANCE',
  Overdraft = 'OVERDRAFT',
  Paypal = 'PAYPAL',
  Payroll = 'PAYROLL',
  Pension = 'PENSION',
  Plan_401A = 'PLAN_401A',
  Plan_401K = 'PLAN_401K',
  Plan_403B = 'PLAN_403B',
  Plan_457B = 'PLAN_457B',
  Plan_529 = 'PLAN_529',
  Prepaid = 'PREPAID',
  Prif = 'PRIF',
  ProfitSharingPlan = 'PROFIT_SHARING_PLAN',
  Qshr = 'QSHR',
  Rdsp = 'RDSP',
  Resp = 'RESP',
  Retirement = 'RETIREMENT',
  Rlif = 'RLIF',
  Roth = 'ROTH',
  Roth_401K = 'ROTH_401K',
  Rrif = 'RRIF',
  Rrsp = 'RRSP',
  Sarsep = 'SARSEP',
  Savings = 'SAVINGS',
  SepIra = 'SEP_IRA',
  SimpleIra = 'SIMPLE_IRA',
  Sipp = 'SIPP',
  StockPlan = 'STOCK_PLAN',
  Student = 'STUDENT',
  Tfsa = 'TFSA',
  ThriftSavingsPlan = 'THRIFT_SAVINGS_PLAN',
  Trust = 'TRUST',
  Ugma = 'UGMA',
  Utma = 'UTMA',
  VariableAnnuity = 'VARIABLE_ANNUITY'
}

export type HasTransactionsResult = {
  __typename?: 'HasTransactionsResult';
  count: Scalars['Int']['output'];
  endDate?: Maybe<Scalars['CalendarDate']['output']>;
  exists: Scalars['Boolean']['output'];
  startDate?: Maybe<Scalars['CalendarDate']['output']>;
};

/** Housing tenure for a residence (rent, mortgage, owned outright, etc.) */
export enum HousingOwnership {
  Mortgage = 'MORTGAGE',
  Other = 'OTHER',
  OwnOutright = 'OWN_OUTRIGHT',
  Rent = 'RENT'
}

export type ICalloutConnection = {
  edges: Array<CalloutEdge>;
  pageInfo: PageInfo;
};

export type ICalloutEdge = {
  cursor: Scalars['String']['output'];
  node: Callout;
};

export type IEntity = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type INode = {
  id: Scalars['ID']['output'];
};

export type ITransactionConnection = {
  edges: Array<TransactionEdge>;
  pageInfo: PageInfo;
};

export type ITransactionEdge = {
  cursor: Scalars['String']['output'];
  node: Transaction;
};

export type LinkDependantsInput = {
  dependantAId: Scalars['ID']['input'];
  dependantBId: Scalars['ID']['input'];
  liveTogether?: InputMaybe<Scalars['Boolean']['input']>;
  relationship: PartnerRelationship;
  relationshipOther?: InputMaybe<Scalars['String']['input']>;
};

export type LogoutOutput = {
  __typename?: 'LogoutOutput';
  success: Scalars['Boolean']['output'];
};

export type Merchant = IEntity & INode & {
  __typename?: 'Merchant';
  id: Scalars['ID']['output'];
  isIncomeSource: Scalars['Boolean']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  recurringTransactions: Array<RecurringTransaction>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createDependantAndRelationship: Family;
  createFinancialAccounts: Array<FinancialAccount>;
  createLinkToken: CreateLinkTokenOutput;
  deleteAccount: DeleteAccountOutput;
  deleteBankConnection: Scalars['String']['output'];
  deleteBill: Scalars['String']['output'];
  deleteDependant?: Maybe<Scalars['ID']['output']>;
  deleteResidence?: Maybe<Scalars['ID']['output']>;
  deleteVehicle?: Maybe<Scalars['ID']['output']>;
  dismissBankConnectionCallout: Array<Scalars['String']['output']>;
  exchangePublicToken: Array<FinancialAccount>;
  linkDependants: Family;
  logout: LogoutOutput;
  sendPhoneVerificationCode: SendPhoneVerificationCodeResult;
  setUserTimezone: User;
  updateCallout?: Maybe<Callout>;
  updateCaregiverRelationship: CaregiverRelationship;
  updateDependant: Dependant;
  updateDependantPartnership: DependantPartnership;
  updateFamilySettings: Family;
  updateFinancialAccount: FinancialAccount;
  updateMerchant: Merchant;
  updateRecurringTransaction: RecurringTransaction;
  updateUser: User;
  upsertResidence: Residence;
  upsertVehicle: Vehicle;
  verifyPhoneNumber: User;
};


export type MutationCreateDependantAndRelationshipArgs = {
  input: CreateDependantAndRelationshipInput;
};


export type MutationCreateFinancialAccountsArgs = {
  input: CreateFinancialAccountsInput;
};


export type MutationCreateLinkTokenArgs = {
  input: CreateLinkTokenInput;
};


export type MutationDeleteBankConnectionArgs = {
  bankConnectionId: Scalars['String']['input'];
};


export type MutationDeleteBillArgs = {
  billId: Scalars['ID']['input'];
};


export type MutationDeleteDependantArgs = {
  input: DeleteDependantInput;
};


export type MutationDeleteResidenceArgs = {
  input: DeleteResidenceInput;
};


export type MutationDeleteVehicleArgs = {
  input: DeleteVehicleInput;
};


export type MutationDismissBankConnectionCalloutArgs = {
  bankConnectionId: Scalars['String']['input'];
};


export type MutationExchangePublicTokenArgs = {
  input: ExchangePublicTokenInput;
};


export type MutationLinkDependantsArgs = {
  input: LinkDependantsInput;
};


export type MutationSetUserTimezoneArgs = {
  timezone: Scalars['String']['input'];
};


export type MutationUpdateCalloutArgs = {
  id: Scalars['ID']['input'];
  input: CalloutUpdateInputGql;
};


export type MutationUpdateCaregiverRelationshipArgs = {
  input: UpdateCaregiverRelationshipInput;
};


export type MutationUpdateDependantArgs = {
  input: UpdateDependantInput;
};


export type MutationUpdateDependantPartnershipArgs = {
  input: UpdateDependantPartnershipInput;
};


export type MutationUpdateFamilySettingsArgs = {
  input: UpdateFamilySettingsInput;
};


export type MutationUpdateFinancialAccountArgs = {
  input: UpdateFinancialAccountInput;
};


export type MutationUpdateMerchantArgs = {
  input: UpdateMerchantInput;
};


export type MutationUpdateRecurringTransactionArgs = {
  input: UpdateRecurringTransactionInput;
};


export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type MutationUpsertResidenceArgs = {
  input: UpsertResidenceInput;
};


export type MutationUpsertVehicleArgs = {
  input: UpsertVehicleInput;
};


export type MutationVerifyPhoneNumberArgs = {
  input: VerifyPhoneNumberInput;
};

export type Obligation = Bill | RecurringTransaction | Transaction;

export type ObligationConnection = {
  __typename?: 'ObligationConnection';
  edges: Array<ObligationEdge>;
  pageInfo: PageInfo;
};

export type ObligationEdge = {
  __typename?: 'ObligationEdge';
  cursor: Scalars['String']['output'];
  node: Obligation;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export enum PaginationDirection {
  Backward = 'BACKWARD',
  Forward = 'FORWARD'
}

export type PaginationInput = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  direction?: PaginationDirection;
  limit: Scalars['Int']['input'];
};

/** How two dependants are partnered (Mom + Dad, etc.) */
export enum PartnerRelationship {
  Divorced = 'DIVORCED',
  DomesticPartner = 'DOMESTIC_PARTNER',
  Other = 'OTHER',
  Spouse = 'SPOUSE'
}

export type PlaidAccountInput = {
  id: Scalars['String']['input'];
  mask: Scalars['String']['input'];
  name: Scalars['String']['input'];
  subtype: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type Query = {
  __typename?: 'Query';
  enabledFeatureGates: Array<Scalars['String']['output']>;
  getAllTransactionsForUser: Array<Transaction>;
  getBankConnectionsForUser: Array<BankConnection>;
  getBill?: Maybe<Bill>;
  getBillSubmission?: Maybe<BillSubmission>;
  getBillSubmissionsForUser: Array<BillSubmission>;
  getBillsForUser: Array<Bill>;
  getCallouts: CalloutConnection;
  getCurrentFamily?: Maybe<Family>;
  getCurrentSession?: Maybe<Session>;
  getCurrentUser?: Maybe<User>;
  getFinancialAccount?: Maybe<FinancialAccount>;
  getFinancialAccounts: Array<FinancialAccount>;
  getFinancialAccountsForUser: Array<FinancialAccount>;
  getMerchant?: Maybe<Merchant>;
  getMerchants: Array<Merchant>;
  getMerchantsForUser: Array<Merchant>;
  getOverdueObligationsForUser: Array<Obligation>;
  getPaidObligationsForUser: ObligationConnection;
  getRecurringTransaction: RecurringTransaction;
  getRecurringTransactionsforUser: Array<RecurringTransaction>;
  getTransaction: Transaction;
  getTransactionCategories: Array<TransactionCategory>;
  getTransactionsForUser: TransactionConnection;
  getUpcomingObligationsForUser: Array<Obligation>;
  getUser?: Maybe<User>;
  hasTransactionsForUser: HasTransactionsResult;
  searchEntities: Array<IEntity>;
  searchTransactions: Array<Transaction>;
};


export type QueryGetBillArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetBillSubmissionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetBillSubmissionsForUserArgs = {
  filters?: InputMaybe<BillSubmissionFilters>;
};


export type QueryGetBillsForUserArgs = {
  filters?: InputMaybe<BillFilters>;
};


export type QueryGetCalloutsArgs = {
  filters?: InputMaybe<CalloutFiltersInput>;
  maxPriority?: InputMaybe<CalloutPriority>;
  pagination: PaginationInput;
};


export type QueryGetFinancialAccountArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetFinancialAccountsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryGetMerchantArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetMerchantsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryGetPaidObligationsForUserArgs = {
  paidPagination?: InputMaybe<PaginationInput>;
};


export type QueryGetRecurringTransactionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetRecurringTransactionsforUserArgs = {
  filters?: InputMaybe<RecurringTransactionFilters>;
};


export type QueryGetTransactionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetTransactionsForUserArgs = {
  filters?: InputMaybe<TransactionFilters>;
  pagination: PaginationInput;
  sortKey?: InputMaybe<TransactionSortKeys>;
};


export type QueryGetUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryHasTransactionsForUserArgs = {
  filters?: InputMaybe<TransactionFilters>;
};


export type QuerySearchEntitiesArgs = {
  input: EntitySearchInput;
};


export type QuerySearchTransactionsArgs = {
  input: TransactionSearchInput;
};

export type RecurringTransaction = INode & {
  __typename?: 'RecurringTransaction';
  amountRange: Array<Scalars['String']['output']>;
  category: TransactionCategory;
  currencyCode: Scalars['String']['output'];
  description: Scalars['String']['output'];
  financialAccount: FinancialAccount;
  firstOccurrence: Scalars['CalendarDate']['output'];
  frequency: RecurringTransactionFrequency;
  id: Scalars['ID']['output'];
  isActive: Scalars['Boolean']['output'];
  lastTransaction?: Maybe<Transaction>;
  latestOccurrence: Scalars['CalendarDate']['output'];
  merchant?: Maybe<Merchant>;
  nextOccurrence?: Maybe<Scalars['CalendarDate']['output']>;
  rawJson?: Maybe<Scalars['JSONObject']['output']>;
  type: RecurringTransactionType;
};

export type RecurringTransactionFilters = {
  financialAccountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  merchantIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum RecurringTransactionFrequency {
  Annually = 'ANNUALLY',
  Biweekly = 'BIWEEKLY',
  Monthly = 'MONTHLY',
  OneTime = 'ONE_TIME',
  SemiMonthly = 'SEMI_MONTHLY',
  Unknown = 'UNKNOWN',
  Weekly = 'WEEKLY'
}

export enum RecurringTransactionType {
  Bill = 'BILL',
  Income = 'INCOME',
  Subscription = 'SUBSCRIPTION'
}

export type Residence = INode & {
  __typename?: 'Residence';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  formatted?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isPrimary: Scalars['Boolean']['output'];
  owner?: Maybe<FamilyMember>;
  ownership?: Maybe<HousingOwnership>;
  ownershipOther?: Maybe<Scalars['String']['output']>;
  placeId?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  residenceType: ResidenceType;
  residenceTypeOther?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

/** Type of residence (house, apartment, assisted living, etc.) */
export enum ResidenceType {
  Apartment = 'APARTMENT',
  AssistedLiving = 'ASSISTED_LIVING',
  Condo = 'CONDO',
  FamilyMember = 'FAMILY_MEMBER',
  FrequentLocation = 'FREQUENT_LOCATION',
  House = 'HOUSE',
  IndependentLiving = 'INDEPENDENT_LIVING',
  NursingHome = 'NURSING_HOME',
  Other = 'OTHER'
}

export type SendPhoneVerificationCodeResult = {
  __typename?: 'SendPhoneVerificationCodeResult';
  retryAfter: Scalars['DateTimeISO']['output'];
};

export type Session = INode & {
  __typename?: 'Session';
  createdAt: Scalars['DateTimeISO']['output'];
  expiresAt: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  impersonatorUserId?: Maybe<Scalars['String']['output']>;
  user: User;
};

export type Transaction = INode & {
  __typename?: 'Transaction';
  amount: Scalars['String']['output'];
  anomalyDetection?: Maybe<TransactionAnomalyDetection>;
  anomalyFeedback?: Maybe<TransactionAnomalyFeedback>;
  bill?: Maybe<Bill>;
  callout?: Maybe<Callout>;
  category: TransactionCategory;
  date: Scalars['CalendarDate']['output'];
  description: Scalars['String']['output'];
  financialAccount?: Maybe<FinancialAccount>;
  id: Scalars['ID']['output'];
  isPending: Scalars['Boolean']['output'];
  isUnverified: Scalars['Boolean']['output'];
  merchant?: Maybe<Merchant>;
  pairedTransaction?: Maybe<Transaction>;
  rawDescription?: Maybe<Scalars['String']['output']>;
  rawJson?: Maybe<Scalars['JSONObject']['output']>;
  recurringTransaction?: Maybe<RecurringTransaction>;
};

export enum TransactionAmountType {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

export type TransactionAnomalyDetection = INode & {
  __typename?: 'TransactionAnomalyDetection';
  anomalyReasons: Array<Scalars['String']['output']>;
  anomalyScore: Scalars['Float']['output'];
  featuresJson: Scalars['JSONObject']['output'];
  id: Scalars['ID']['output'];
  scoreParts: AnomalyScoreParts;
};

export type TransactionAnomalyFeedback = INode & {
  __typename?: 'TransactionAnomalyFeedback';
  detailedReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  priority: TransactionAnomalyPriority;
};

/** Priority level for transaction anomaly feedback */
export enum TransactionAnomalyPriority {
  P0 = 'P0',
  P1 = 'P1',
  P2 = 'P2',
  P3 = 'P3',
  P4 = 'P4'
}

export type TransactionCategory = INode & {
  __typename?: 'TransactionCategory';
  detailedType?: Maybe<TransactionCategoryDetailedType>;
  id: Scalars['ID']['output'];
  type: TransactionCategoryPrimaryType;
};

export enum TransactionCategoryDetailedType {
  BankFeesAtmFees = 'BANK_FEES_ATM_FEES',
  BankFeesForeignTransactionFees = 'BANK_FEES_FOREIGN_TRANSACTION_FEES',
  BankFeesInsufficientFunds = 'BANK_FEES_INSUFFICIENT_FUNDS',
  BankFeesInterestCharge = 'BANK_FEES_INTEREST_CHARGE',
  BankFeesOtherBankFees = 'BANK_FEES_OTHER_BANK_FEES',
  BankFeesOverdraftFees = 'BANK_FEES_OVERDRAFT_FEES',
  EntertainmentCasinosAndGambling = 'ENTERTAINMENT_CASINOS_AND_GAMBLING',
  EntertainmentMusicAndAudio = 'ENTERTAINMENT_MUSIC_AND_AUDIO',
  EntertainmentOtherEntertainment = 'ENTERTAINMENT_OTHER_ENTERTAINMENT',
  EntertainmentSportingEventsAmusementParksAndMuseums = 'ENTERTAINMENT_SPORTING_EVENTS_AMUSEMENT_PARKS_AND_MUSEUMS',
  EntertainmentTvAndMovies = 'ENTERTAINMENT_TV_AND_MOVIES',
  EntertainmentVideoGames = 'ENTERTAINMENT_VIDEO_GAMES',
  FoodAndDrinkBeerWineAndLiquor = 'FOOD_AND_DRINK_BEER_WINE_AND_LIQUOR',
  FoodAndDrinkCoffee = 'FOOD_AND_DRINK_COFFEE',
  FoodAndDrinkFastFood = 'FOOD_AND_DRINK_FAST_FOOD',
  FoodAndDrinkGroceries = 'FOOD_AND_DRINK_GROCERIES',
  FoodAndDrinkOtherFoodAndDrink = 'FOOD_AND_DRINK_OTHER_FOOD_AND_DRINK',
  FoodAndDrinkRestaurant = 'FOOD_AND_DRINK_RESTAURANT',
  FoodAndDrinkVendingMachines = 'FOOD_AND_DRINK_VENDING_MACHINES',
  GeneralMerchandiseBookstoresAndNewsstands = 'GENERAL_MERCHANDISE_BOOKSTORES_AND_NEWSSTANDS',
  GeneralMerchandiseClothingAndAccessories = 'GENERAL_MERCHANDISE_CLOTHING_AND_ACCESSORIES',
  GeneralMerchandiseConvenienceStores = 'GENERAL_MERCHANDISE_CONVENIENCE_STORES',
  GeneralMerchandiseDepartmentStores = 'GENERAL_MERCHANDISE_DEPARTMENT_STORES',
  GeneralMerchandiseDiscountStores = 'GENERAL_MERCHANDISE_DISCOUNT_STORES',
  GeneralMerchandiseElectronics = 'GENERAL_MERCHANDISE_ELECTRONICS',
  GeneralMerchandiseGiftsAndNovelties = 'GENERAL_MERCHANDISE_GIFTS_AND_NOVELTIES',
  GeneralMerchandiseOfficeSupplies = 'GENERAL_MERCHANDISE_OFFICE_SUPPLIES',
  GeneralMerchandiseOnlineMarketplaces = 'GENERAL_MERCHANDISE_ONLINE_MARKETPLACES',
  GeneralMerchandiseOtherGeneralMerchandise = 'GENERAL_MERCHANDISE_OTHER_GENERAL_MERCHANDISE',
  GeneralMerchandisePetSupplies = 'GENERAL_MERCHANDISE_PET_SUPPLIES',
  GeneralMerchandiseSportingGoods = 'GENERAL_MERCHANDISE_SPORTING_GOODS',
  GeneralMerchandiseSuperstores = 'GENERAL_MERCHANDISE_SUPERSTORES',
  GeneralMerchandiseTobaccoAndVape = 'GENERAL_MERCHANDISE_TOBACCO_AND_VAPE',
  GeneralServicesAccountingAndFinancialPlanning = 'GENERAL_SERVICES_ACCOUNTING_AND_FINANCIAL_PLANNING',
  GeneralServicesAutomotive = 'GENERAL_SERVICES_AUTOMOTIVE',
  GeneralServicesChildcare = 'GENERAL_SERVICES_CHILDCARE',
  GeneralServicesConsultingAndLegal = 'GENERAL_SERVICES_CONSULTING_AND_LEGAL',
  GeneralServicesEducation = 'GENERAL_SERVICES_EDUCATION',
  GeneralServicesInsurance = 'GENERAL_SERVICES_INSURANCE',
  GeneralServicesOtherGeneralServices = 'GENERAL_SERVICES_OTHER_GENERAL_SERVICES',
  GeneralServicesPostageAndShipping = 'GENERAL_SERVICES_POSTAGE_AND_SHIPPING',
  GeneralServicesStorage = 'GENERAL_SERVICES_STORAGE',
  GovernmentAndNonProfitDonations = 'GOVERNMENT_AND_NON_PROFIT_DONATIONS',
  GovernmentAndNonProfitGovernmentDepartmentsAndAgencies = 'GOVERNMENT_AND_NON_PROFIT_GOVERNMENT_DEPARTMENTS_AND_AGENCIES',
  GovernmentAndNonProfitOtherGovernmentAndNonProfit = 'GOVERNMENT_AND_NON_PROFIT_OTHER_GOVERNMENT_AND_NON_PROFIT',
  GovernmentAndNonProfitTaxPayment = 'GOVERNMENT_AND_NON_PROFIT_TAX_PAYMENT',
  HomeImprovementFurniture = 'HOME_IMPROVEMENT_FURNITURE',
  HomeImprovementHardware = 'HOME_IMPROVEMENT_HARDWARE',
  HomeImprovementOtherHomeImprovement = 'HOME_IMPROVEMENT_OTHER_HOME_IMPROVEMENT',
  HomeImprovementRepairAndMaintenance = 'HOME_IMPROVEMENT_REPAIR_AND_MAINTENANCE',
  HomeImprovementSecurity = 'HOME_IMPROVEMENT_SECURITY',
  IncomeDividends = 'INCOME_DIVIDENDS',
  IncomeInterestEarned = 'INCOME_INTEREST_EARNED',
  IncomeOtherIncome = 'INCOME_OTHER_INCOME',
  IncomeRetirementPension = 'INCOME_RETIREMENT_PENSION',
  IncomeTaxRefund = 'INCOME_TAX_REFUND',
  IncomeUnemployment = 'INCOME_UNEMPLOYMENT',
  IncomeWages = 'INCOME_WAGES',
  LoanPaymentsCarPayment = 'LOAN_PAYMENTS_CAR_PAYMENT',
  LoanPaymentsCreditCardPayment = 'LOAN_PAYMENTS_CREDIT_CARD_PAYMENT',
  LoanPaymentsMortgagePayment = 'LOAN_PAYMENTS_MORTGAGE_PAYMENT',
  LoanPaymentsOtherPayment = 'LOAN_PAYMENTS_OTHER_PAYMENT',
  LoanPaymentsPersonalLoanPayment = 'LOAN_PAYMENTS_PERSONAL_LOAN_PAYMENT',
  LoanPaymentsStudentLoanPayment = 'LOAN_PAYMENTS_STUDENT_LOAN_PAYMENT',
  MedicalDentalCare = 'MEDICAL_DENTAL_CARE',
  MedicalEyeCare = 'MEDICAL_EYE_CARE',
  MedicalNursingCare = 'MEDICAL_NURSING_CARE',
  MedicalOtherMedical = 'MEDICAL_OTHER_MEDICAL',
  MedicalPharmaciesAndSupplements = 'MEDICAL_PHARMACIES_AND_SUPPLEMENTS',
  MedicalPrimaryCare = 'MEDICAL_PRIMARY_CARE',
  MedicalVeterinaryServices = 'MEDICAL_VETERINARY_SERVICES',
  Other = 'OTHER',
  PersonalCareGymsAndFitnessCenters = 'PERSONAL_CARE_GYMS_AND_FITNESS_CENTERS',
  PersonalCareHairAndBeauty = 'PERSONAL_CARE_HAIR_AND_BEAUTY',
  PersonalCareLaundryAndDryCleaning = 'PERSONAL_CARE_LAUNDRY_AND_DRY_CLEANING',
  PersonalCareOtherPersonalCare = 'PERSONAL_CARE_OTHER_PERSONAL_CARE',
  RentAndUtilitiesGasAndElectricity = 'RENT_AND_UTILITIES_GAS_AND_ELECTRICITY',
  RentAndUtilitiesInternetAndCable = 'RENT_AND_UTILITIES_INTERNET_AND_CABLE',
  RentAndUtilitiesOtherUtilities = 'RENT_AND_UTILITIES_OTHER_UTILITIES',
  RentAndUtilitiesRent = 'RENT_AND_UTILITIES_RENT',
  RentAndUtilitiesSewageAndWasteManagement = 'RENT_AND_UTILITIES_SEWAGE_AND_WASTE_MANAGEMENT',
  RentAndUtilitiesTelephone = 'RENT_AND_UTILITIES_TELEPHONE',
  RentAndUtilitiesWater = 'RENT_AND_UTILITIES_WATER',
  TransferInAccountTransfer = 'TRANSFER_IN_ACCOUNT_TRANSFER',
  TransferInCashAdvancesAndLoans = 'TRANSFER_IN_CASH_ADVANCES_AND_LOANS',
  TransferInDeposit = 'TRANSFER_IN_DEPOSIT',
  TransferInInvestmentAndRetirementFunds = 'TRANSFER_IN_INVESTMENT_AND_RETIREMENT_FUNDS',
  TransferInOtherTransferIn = 'TRANSFER_IN_OTHER_TRANSFER_IN',
  TransferInSavings = 'TRANSFER_IN_SAVINGS',
  TransferOutAccountTransfer = 'TRANSFER_OUT_ACCOUNT_TRANSFER',
  TransferOutInvestmentAndRetirementFunds = 'TRANSFER_OUT_INVESTMENT_AND_RETIREMENT_FUNDS',
  TransferOutOtherTransferOut = 'TRANSFER_OUT_OTHER_TRANSFER_OUT',
  TransferOutSavings = 'TRANSFER_OUT_SAVINGS',
  TransferOutWithdrawal = 'TRANSFER_OUT_WITHDRAWAL',
  TransportationBikesAndScooters = 'TRANSPORTATION_BIKES_AND_SCOOTERS',
  TransportationGas = 'TRANSPORTATION_GAS',
  TransportationOtherTransportation = 'TRANSPORTATION_OTHER_TRANSPORTATION',
  TransportationParking = 'TRANSPORTATION_PARKING',
  TransportationPublicTransit = 'TRANSPORTATION_PUBLIC_TRANSIT',
  TransportationTaxisAndRideShares = 'TRANSPORTATION_TAXIS_AND_RIDE_SHARES',
  TransportationTolls = 'TRANSPORTATION_TOLLS',
  TravelFlights = 'TRAVEL_FLIGHTS',
  TravelLodging = 'TRAVEL_LODGING',
  TravelOtherTravel = 'TRAVEL_OTHER_TRAVEL',
  TravelRentalCars = 'TRAVEL_RENTAL_CARS'
}

export enum TransactionCategoryPrimaryType {
  BankFees = 'BANK_FEES',
  Entertainment = 'ENTERTAINMENT',
  FoodAndDrink = 'FOOD_AND_DRINK',
  GeneralMerchandise = 'GENERAL_MERCHANDISE',
  GeneralServices = 'GENERAL_SERVICES',
  GovernmentAndNonProfit = 'GOVERNMENT_AND_NON_PROFIT',
  HomeImprovement = 'HOME_IMPROVEMENT',
  Income = 'INCOME',
  LoanPayments = 'LOAN_PAYMENTS',
  Medical = 'MEDICAL',
  Other = 'OTHER',
  PersonalCare = 'PERSONAL_CARE',
  RentAndUtilities = 'RENT_AND_UTILITIES',
  TransferIn = 'TRANSFER_IN',
  TransferOut = 'TRANSFER_OUT',
  Transportation = 'TRANSPORTATION',
  Travel = 'TRAVEL',
  Unknown = 'UNKNOWN'
}

export type TransactionConnection = ITransactionConnection & {
  __typename?: 'TransactionConnection';
  edges: Array<TransactionEdge>;
  pageInfo: PageInfo;
};

export type TransactionEdge = ITransactionEdge & {
  __typename?: 'TransactionEdge';
  cursor: Scalars['String']['output'];
  node: Transaction;
};

export type TransactionFilters = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  endDate?: InputMaybe<Scalars['CalendarDate']['input']>;
  excludePaired?: InputMaybe<Scalars['Boolean']['input']>;
  financialAccountIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  merchantIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  recurringTransactionId?: InputMaybe<Scalars['ID']['input']>;
  search?: InputMaybe<TransactionSearchFilter>;
  startDate?: InputMaybe<Scalars['CalendarDate']['input']>;
  transactionAmountType?: InputMaybe<TransactionAmountType>;
};

export enum TransactionSearchAxis {
  FinancialAccount = 'FINANCIAL_ACCOUNT',
  Merchant = 'MERCHANT'
}

export type TransactionSearchFilter = {
  query: Scalars['String']['input'];
  types: Array<TransactionSearchAxis>;
};

export type TransactionSearchInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};

export enum TransactionSortKeys {
  Amount = 'AMOUNT',
  Date = 'DATE'
}

export type UpdateCaregiverRelationshipInput = {
  caregiverRelationshipId: Scalars['ID']['input'];
  isInLaw?: InputMaybe<Scalars['Boolean']['input']>;
  isStep?: InputMaybe<Scalars['Boolean']['input']>;
  livesWithCaregiver?: InputMaybe<Scalars['Boolean']['input']>;
  relationship?: InputMaybe<CaregiverRelationshipKind>;
  relationshipOther?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDependantInput = {
  avatarUrl?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['CalendarDate']['input']>;
  dependantId: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  preferredName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDependantPartnershipInput = {
  dependantPartnershipId: Scalars['ID']['input'];
  liveTogether?: InputMaybe<Scalars['Boolean']['input']>;
  relationship?: InputMaybe<PartnerRelationship>;
  relationshipOther?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFamilySettingsInput = {
  creditUtilizationThreshold?: InputMaybe<Scalars['Float']['input']>;
  lowBalanceThreshold?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateFinancialAccountInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdateMerchantInput = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type UpdateRecurringTransactionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

export type UpdateUserInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  preferredName?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertResidenceInput = {
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  country: Scalars['String']['input'];
  dependantId?: InputMaybe<Scalars['ID']['input']>;
  formatted?: InputMaybe<Scalars['String']['input']>;
  isPrimary: Scalars['Boolean']['input'];
  ownership?: InputMaybe<HousingOwnership>;
  ownershipOther?: InputMaybe<Scalars['String']['input']>;
  placeId?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  residenceId?: InputMaybe<Scalars['ID']['input']>;
  residenceType: ResidenceType;
  residenceTypeOther?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpsertVehicleInput = {
  dependantId?: InputMaybe<Scalars['ID']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  ownership: VehicleOwnership;
  ownershipOther?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  vehicleId?: InputMaybe<Scalars['ID']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type User = IEntity & INode & {
  __typename?: 'User';
  avatarUrl?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTimeISO']['output'];
  email: Scalars['String']['output'];
  family: Family;
  financialAccounts: Array<FinancialAccount>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  merchants: Array<Merchant>;
  name: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberVerifiedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  preferredName?: Maybe<Scalars['String']['output']>;
  primaryResidence?: Maybe<Residence>;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type Vehicle = INode & {
  __typename?: 'Vehicle';
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['ID']['output'];
  make?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  ownership: VehicleOwnership;
  ownershipOther?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

/** Vehicle tenure (loan, lease, owned outright, etc.) */
export enum VehicleOwnership {
  Lease = 'LEASE',
  Loan = 'LOAN',
  Other = 'OTHER',
  OwnOutright = 'OWN_OUTRIGHT'
}

export type VerifyPhoneNumberInput = {
  code: Scalars['String']['input'];
};
